module.exports = __webpack_public_path__ + "img/basics2.e64ac182.png";